<template>
    <div>
        <template v-if="isPageAllowed">
            <div v-if="curPage=='assist_tools_overview'" v-loading="mixinLoading" class="page-wrap">
                <el-row :gutter="20">
                    <el-col :lg="8" :xl="6" v-if="pageActionNames.includes('material_export_by_id')">
                        <div class="card-item">
                            <el-card class="box-card">
                                <ToolCard
                                    title="素材内容导出"
                                    desc="按照素材ID导出素材链接等内容"
                                    icon="sucaineirongdaochu"
                                    @click.native="clickCard('material_export_by_id')"
                                />
                            </el-card>
                        </div>
                    </el-col>
                    <el-col :lg="8" :xl="6" v-if="pageActionNames.includes('infrastructure_export_by_id')">
                        <div class="card-item">
                            <el-card class="box-card">
                                <ToolCard
                                    title="基建数据导出"
                                    desc="分媒体导出分日广告创建数据"
                                    icon="jijianshujudaochu"
                                    @click.native="clickCard('infrastructure_export_by_id')"
                                />
                            </el-card>
                        </div>
                    </el-col>
                    <el-col :lg="8" :xl="6" v-if="!mixinLoading">
                        <div class="card-item">
                            <el-card class="box-card">
                                <ToolCard
                                    title="敬请期待"
                                    desc="更多工具敬请期待..."
                                    icon="jingqingqidai"
                                    disabled
                                />
                            </el-card>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <MaterialExportPage v-else-if="curPage=='material_export_by_id'" :allowed-plat-ids="allowedPlatIds" @back="showListPage" />
            <BaseExportPage v-else-if="curPage=='infrastructure_export_by_id'" :allowed-plat-ids="allowedPlatIds" @back="showListPage" />
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>自动化报告可满足对内对外所有报告的自动生产及发送。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import MaterialExportPage from './page/materialExportPage.vue';
    import BaseExportPage from './page/baseExportPage.vue';
    import ToolCard from './components/toolCard';

    export default {
        name: "AssistTools",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            MaterialExportPage,
            ToolCard,
            BaseExportPage,
        },
        data() {
            return {
                curPage:'',
            }
        },
        computed:{
            allowedPlatIds(){
                let platList = this.allowedPlatList||[];
                return platList.map(item=>item.id);
            },
            pageActionNames(){
                let pageAction = this.pageAction||[];
                return pageAction.map(item=>item.name);
            },
        },
        mounted(){
            console.log(this.$route,222)
            // let routeName = this.$route.name;
            // this.curPage = routeName;
        },
        methods:{
            initPageStates(){
                console.log('initPageStates');
                console.log('pageFunc',this.pageFunc);
                console.log('pageFields',this.pageFields);
                this.curPage = this.$route.name;
            },
            clickCard(type){
                console.log('clickCard',type);
                if(type==this.$route.name){
                    this.curPage = type;
                    this.$router.push({
                        name:type,
                    });
                }else{
                    this.$router.push({
                        name:type,
                    });
                }

            },
            showListPage(){
                this.$router.go(-1);
                this.curPage = 'assist_tools_overview';
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page-wrap{
        min-height: 200px;
    }
</style>
